<button class="btn-control btn-move">
    <span class="sp-icon icon-move"> </span>
</button>
